import React from "react";
import { Eye, Calendar, AtSign, User, Folder } from "lucide-react";
import { SecureLink } from "../api/ApiTypes.ts";
import { MetadataRow } from "./MetaDataRow.tsx";
import { formatDateTime } from "../utils/dateUtils.ts";

// SecureLinkItem component - for listing in the SecureLinks page
export const SecureLinkItem: React.FC<{
    secureLink: SecureLink,
    onView: () => void  // Add new prop to handle view action externally
}> = ({ secureLink, onView }) => {
    return (
        <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden">
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    {/* Main content area */}
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className="p-2 bg-blue-50 rounded-md flex-shrink-0">
                                <Folder className="h-8 w-8 text-blue-600" />
                            </div>
                            <div>
                                <div className=" lg:text-base text-slate-800 break-all">
                                    <MetadataRow icon={''} label={`File Number:`} value={secureLink.usaFileNumber}/>
                                </div>
                                <p className="text-sm sm:text-base text-slate-500 mt-1">
                                    <MetadataRow icon={''} label={`Subject:`} value={secureLink.subject}/>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Action buttons */}
                    <div className="flex-shrink-0">
                        <button
                            onClick={onView}
                            className="inline-flex items-center px-3 py-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition-colors hover:cursor-pointer"
                        >
                            <Eye className="h-4 w-4 mr-1" />
                            View
                        </button>
                    </div>
                </div>

                {/* Metadata */}
                <div className="mt-4 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs">
                    <MetadataRow icon={<User className="h-4 w-4 mr-1 text-blue-700" />} label={`From:`} value={secureLink.senderName}/>
                    <MetadataRow icon={<AtSign className="h-4 w-4 mr-1 text-blue-700" />} label={`Email:`} value={secureLink.senderEmail}/>
                    <MetadataRow icon={<Calendar className="h-4 w-4 mr-1 text-blue-700" />} label={`Sent:`} value={formatDateTime(secureLink.sentDateTime)}/>
                </div>
            </div>
        </div>
    );
};